import styled, { css, keyframes } from "styled-components";


export const AssigneeListTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "auto auto auto auto auto"};
  grid-column-gap: 5px;
  padding: ${({ padding, theme }) => padding || theme.table.tableHeaderPadding};
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || "center"};
  cursor: pointer;
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
  width: 100%;
  border-radius: 5px 5px 0 0;
  margin: 0px;
`;

export const AssigneeListTableRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns || "auto auto auto auto auto"};
  grid-column-gap: 5px;
  padding: ${({ padding, theme }) => padding || theme.table.tableHeaderPadding};
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  justify-content: ${({ justifyContent }) => justifyContent || "center"};
  border-bottom: 1px solid #c2cce1;
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
`;

export const ApprovalTaskListTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns, orgType }) =>
    columns ||
    (orgType === "service"
      ? "minmax(50px, 250px)  minmax(70px, 200px) minmax(100px, 250px) minmax(100px, 200px) 200px minmax(100px, 200px)"
      : "minmax(50px, 200px) minmax(80px, 200px) minmax(70px, 200px) minmax(100px, 200px) 200px minmax(100px, 200px)")};
  grid-column-gap: 5px;
  padding: ${({ padding, theme }) => padding || theme.table.tableHeaderPadding};
  align-items: center;
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.tableHeaderBackground};
  width: 100%;
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.table.tableRowBorderRadius};
  margin: 0px;
`;

export const ApprovalTaskListTableRowContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns, orgType }) =>
    columns ||
    (orgType === "service"
      ? "minmax(50px, 250px)  minmax(70px, 200px) minmax(100px, 250px) minmax(100px, 200px) 200px minmax(100px, 200px)"
      : "minmax(50px, 200px) minmax(80px, 200px) minmax(70px, 200px) minmax(100px, 200px) 200px minmax(100px, 200px)")};
  grid-column-gap: 5px;
  padding: ${({ padding, theme }) => padding || theme.table.tableRowPadding};
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.tableBorder};
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
`;